import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import { DateFormatter2 } from '../Common/dateFormat';
import _ from 'lodash';
import { isGGI, isHMM, isSW } from '../../actions/root_url';

const ESCAPE_KEY = 27;
const ENTER_KEY = 13;

const { Selectors } = Data;

export class OcmMultiBatch extends Component {
  constructor() {
    super();
    this.state = {
      rows: [],
      selectedRows: null,
      editedRows: [],
      filters: {},

      quantityRemaining: 0,
    }
  }

  componentDidMount() {
    if (this.props.batchesInfo && this.props.batchesInfo.batches.length) {
      const {
        batches,
      } = this.props.generateBatchRelatedInfo(this.props.selectedInventoryRow.ProductNum)
      this.initializeModal(batches);
    }
    document.addEventListener("keydown", this._handleKeyDown);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this._handleKeyDown);
  }

  _handleKeyDown = (event) => {
    switch (event.keyCode) {
      case ENTER_KEY:
        this.handleOnSubmit();
        break;
      default:
        break;
    }
  }

  componentWillReceiveProps(nextProps) {
  }

  initializeModal = (array) => {
    const {
      selectedInventoryRow
    } = this.props;
    const IsOverSaleable = selectedInventoryRow ? selectedInventoryRow.IsOverSaleable : false;

    let index = 0;
    let formatter = [];
    let quantityRemaining = this.props.quantityValue;
    if (array && array.length > 0) {
      array.map(r => {
        let qty = 0;
        if (r.quantity >= quantityRemaining) {
          qty = quantityRemaining;
          quantityRemaining = 0;
        } else {
          if (r.quantity >= 0) {
            qty = r.quantity;
            quantityRemaining -= r.quantity;
          }
        }
        if(isGGI) {
          formatter.push({ Idx: index++, batchId: r.id, quantity: qty,
            expire_datetime: r.expire_datetime, location: r.location, batch_num: r.batch_num,
            availableQty: r.quantity, is_initial_batch: r.is_initial_batch,
            case_per_layer: r.case_per_layer, layer_per_pallet: r.layer_per_pallet,is_expired:r.is_expired,
          });
        } else if(isSW) {
          formatter.push({ Idx: index++, batchId: r.id, quantity: qty,
            expire_datetime: r.expire_datetime, location: r.location, batch_num: r.batch_num,
            availableQty: r.quantity, is_initial_batch: r.is_initial_batch,
            case_per_layer: r.case_per_layer, layer_per_pallet: r.layer_per_pallet,
            barcode: r.barcode,
          });
        } else {
          formatter.push({ Idx: index++, batchId: r.id, quantity: qty,
            expire_datetime: r.expire_datetime, location: r.location, batch_num: r.batch_num,
            availableQty: r.quantity, is_initial_batch: r.is_initial_batch,
            case_per_layer: r.case_per_layer, layer_per_pallet: r.layer_per_pallet,
          });
        }
      })
    } else {
      formatter = [];
      // formatter.push({ Idx: 0, batchId: null, quantity: "0", expire_datetime: null, location: null, batch_num: null, availableQty: null });
    }
    // for HMM doesnt matters or isOverSaleable
    if ((quantityRemaining && IsOverSaleable) || (quantityRemaining && isHMM)) {
      const initialBatchIndex = _.findIndex(formatter, batch => batch.is_initial_batch);
      formatter[initialBatchIndex].quantity += parseInt(quantityRemaining);
      quantityRemaining = 0;
    }
    this.setState({
      rows: formatter,
      selectedRows: [],
      editedRows: [],
      quantityRemaining,
    });
  }

  handleOnSubmit = (e) => {
    const {
      rows,
    } = this.state;
    this.props.onSelectedMultiBatch(rows);
  };

  onClickAddAll(idx) {
    const {
      selectedInventoryRow,
    } = this.props;
    const {
      IsOverSaleable,
    } = selectedInventoryRow;
    let { rows, quantityRemaining } = this.state;
    rows.map((r, index) => {
      if (r.Idx === idx) {
        quantityRemaining = Number(quantityRemaining) + Number(rows[index].quantity);
        if (r.availableQty >= quantityRemaining || (IsOverSaleable && r.is_initial_batch)) {
          rows[index].quantity = quantityRemaining;
          quantityRemaining = 0;
        } else {
          rows[index].quantity = r.availableQty;
          quantityRemaining = Number(quantityRemaining) - Number(r.availableQty);
        }
      }
    });
    this.setState({ rows, quantityRemaining });
  }

  onClickRemoveAll(idx) {
    let { rows, quantityRemaining } = this.state;
    rows.map((r, index) => {
      if (r.Idx === idx) {
        quantityRemaining = Number(quantityRemaining) + Number(rows[index].quantity);
        rows[index].quantity = 0;
      }
    });
    this.setState({ rows, quantityRemaining });
  }

  renderAgentTable() {
    const getRows = () => {
      return Selectors.getRows(this.state);
    }
    const getSize = () => {
      return getRows().length;
    }
    const rowGetter = rowIdx => {
      var rows = getRows();
      return rows[rowIdx];
    }

    const handleRowUpdated = e => {
      const {
        IsOverSaleable,
      } = this.props.selectedInventoryRow;

      this.setState({ sortColumn: null, sortDirection: null })
      let { quantityRemaining } = this.state;
      let rows = getRows();
      let editedRows = this.state.editedRows.slice(0);
      const line = rows[e.rowIdx];
      const canExceed = IsOverSaleable && line.is_initial_batch;
      if (e.updated && e.updated.quantity > line.availableQty && !canExceed) {
        alert("Cannot exceed available quantity.");
        return;
      } else if (e.updated && e.updated.quantity > quantityRemaining) {
        alert("Cannot exceed remaining quantity.");
        return;
      } else if ((Number(e.updated.quantity) !== Number(rows[e.rowIdx].quantity))) {
        this.setState({ quantityRemaining: Number(this.state.quantityRemaining) + Number(rows[e.rowIdx].quantity) - Number(e.updated.quantity) });
      }

      Object.assign(rows[e.rowIdx], e.updated);
      editedRows.forEach((element, index) => {
        if (element.Idx === rows[e.rowIdx].Idx)
          editedRows.splice(index, 1)
      }, this);
      editedRows.push(rows[e.rowIdx]);
      this.setState({
        rows: rows,
        editedRows: editedRows,
      });
    }
    const onRowsSelected = (rows) => {
      let newRows = getRows();
      let selectedRows = [...this.state.selectedRows];
      rows.map(r => {
        newRows[r.rowIdx].isSelected = true;
        selectedRows.push(r.row);
      });
      this.setState({ rows: newRows, selectedRows });
    }
    const onRowsDeselected = (rows) => {
      let newRows = [...this.state.rows];
      let selectedRows = [...this.state.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
        const rowIndex = selectedRows.indexOf(r.row);
        selectedRows.splice(rowIndex, 1);
      });
      this.setState({ rows: newRows, selectedRows });
    }

    const columns = [
      {
        key: 'Idx',
        name: <Translate value="operation" />,
        resizable: true,
        width: 100,
        formatter: ({ value, dependentValues }) => (
          <div
            style={{ width: '100%' }}
          >
            <span onClick={() => {
              this.onClickAddAll(value);
            }}
              style={{ cursor: "pointer", color: "green", marginRight: '12px' }}
            >+All</span>
            <span onClick={() => {
              this.onClickRemoveAll(value);
            }}
              style={{ cursor: "pointer", color: "red" }}
            >-All</span>
          </div>
        ),
        width: 100,
        getRowMetaData: (row) => row,
      },
      {
        key: 'quantity',
        name: <Translate value="quantity" />,
        resizable: true,
        sortable: true,
        filterable: true,
        editable: true,
        width: 90,
      },
      {
        key: 'availableQty',
        name: <Translate value="available" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
      {
        key: 'expire_datetime',
        name: <Translate value="expired" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
        formatter: DateFormatter2,
      },
      {
        key: 'location',
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
      },
      {
        key: 'batch_num',
        name: <Translate value="batch_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
    ]

    if (isGGI) {
      const batchNumIdx = _.findIndex(columns, { key: 'batch_num' });
      const casePerLayer = {
        key: 'case_per_layer',
        name: <Translate value="case_per_layer" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      };
      const layerPerPallet = {
        key: 'layer_per_pallet',
        name: <Translate value="layer_per_pallet" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      }
      columns.splice(batchNumIdx, 0, casePerLayer, layerPerPallet);
    } 

    return (
      <Row>
        <label style={{ color: 'orange', fontSize: '15px' }}><Translate value="quantity_remaining" />: {this.state.quantityRemaining}</label>
        <Col>
          <div style={{ maxWidth: '650px', marginLeft: '25px' }}>
            <ReactDataGrid
              // rowKey="Idx"
              enableCellSelect={true}
              rowRenderer={
                <RowRenderer />
              }
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={300}
              rowHeight={25}
              headerRowHeight={45}
              // enableRowSelect='single'
              onRowUpdated={handleRowUpdated}
            // rowSelection={{
            //     showCheckbox: true,
            //     onRowsSelected,
            //     onRowsDeselected,
            //     selectBy: {
            //         isSelectedKey: 'isSelected'
            //     }
            // }}
            />
          </div>
        </Col>
      </Row>
    )
  }

  render() {
    const {
    } = this.state;
    return (
      <div>
        {/* <ButtonToolbar style={{ marginLeft: '5px', marginBottom: '7px' }}>
                    <Button
                        bsStyle="primary"
                        onClick={(event) => { this.clickNew(event) }}
                    >
                        <em className="fa fa-plus marginRightStyle" /><Translate value="add" />
                    </Button>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="danger"
                        onClick={(event) => { this.deleteCategory(event) }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}
                    ><em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                    </Button>
                </ButtonToolbar> */}
        <Row>
          <Col className="text-center">
            <span>
              {this.renderAgentTable()}
            </span>
          </Col>
        </Row>

        <Row className="centerStyle" style={{ marginTop: '20px' }}>
          <Button
            style={{ marginRight: '5px' }}
            bsStyle="success"
            onClick={(e) => { this.handleOnSubmit(e); }}
          >
            <Translate value="add_batches" />
          </Button>
        </Row>
      </div>
    );
  }
}

class RowRenderer extends Component {
  render() {
    return (
      <div
        style={{color:'black'}}
      >
        <ReactDataGrid.Row ref="row" {...this.props} />
      </div>
    );
  }
}

export default OcmMultiBatch;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/ocmMultiBatch.jsx